import BaseSelect from 'components/Selects/BaseSelect/BaseSelect';
import { findSelectOption } from 'components/Selects/BaseSelect/utils/baseSelect.utils';
import { useEffect } from 'react';

const FIELD_STYLES = {
  control: (base) => ({ ...base, minHeight: 38 }),
};

export default function DeviceCustomInput({ onChange, value, dataMapItem, readOnly = false }) {
  const { type, units, values } = dataMapItem || {};

  useEffect(() => {
    if (value === null || value === undefined) {
      switch (type) {
        case 'float':
          onChange(0.0);
          break;
        case 'bool':
          onChange(false);
          break;
        default:
          onChange(null);
          break;
      }
    }
  }, [type]);

  if (type === 'float') {
    return (
      <div className="d-flex align-items-center gap-2 w-100">
        <input
          style={{ height: '38px' }}
          className="global-action-builder-field px-2 rounded-3 w-100"
          type="number"
          step="any"
          inputMode="decimal"
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}
        />
        {units ? <div className="text-body-secondary">{units}</div> : null}
      </div>
    );
  }

  if (type === 'bool') {
    // Keep DOM values as strings; coerce to boolean on change
    const current = value === true ? 'true' : 'false';
    const trueLabel = values?.['true'] ?? 'True';
    const falseLabel = values?.['false'] ?? 'False';

    const boolOptions = [
      { value: 'true', label: trueLabel },
      { value: 'false', label: falseLabel },
    ];

    return (
      <BaseSelect
        styles={FIELD_STYLES}
        classNames={{ control: () => 'global-action-builder-field' }}
        selectProps={{
          options: boolOptions,
          value: findSelectOption(boolOptions, current),
          isDisabled: readOnly,
          onChange: (option) => onChange(option?.value === 'true'),
        }}
      />
    );
  }

  // Support for integer status fields with a values map (e.g., 1/0 for Closed/Open)
  if (type === 'int' && values && typeof values === 'object') {
    // Convert value to string for select
    const current = value !== undefined && value !== null ? String(value) : '';
    const intOptions = Object.entries(values).map(([k, v]) => ({ value: k, label: v }));

    return (
      <BaseSelect
        styles={FIELD_STYLES}
        classNames={{ control: () => 'global-action-builder-field' }}
        selectProps={{
          options: intOptions,
          value: findSelectOption(intOptions, current),
          placeholder: '-Select-',
          isDisabled: readOnly,
          onChange: (option) =>
            onChange(
              option?.value === undefined || option?.value === '' ? null : Number(option.value),
            ),
        }}
      />
    );
  }

  return null;
}
